import type { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const CvvIcon = (props: SvgIconProps) => {
  return (
    <svg
      width="37"
      height="15"
      viewBox="0 0 50 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(15, 0)">
        {' '}
        {/* Shift the entire SVG content to the right */}
        <rect
          width="50"
          height="35"
          rx="3"
          fill="#d3d3d3"
          stroke="#BDBDBD"
          strokeWidth="1"
        />
        <rect
          x="0"
          y="5"
          width="50"
          height="7"
          fill="#a6a6a6"
        />
        <rect
          x="3"
          y="15"
          width="30"
          height="6"
          fill="#fff"
        />
        <g transform="translate(28, -10)">
          {' '}
          {/* Modified to be relative to the outer g */}
          <circle
            cx="12"
            cy="22"
            r="12"
            fill="#000"
          />
          <text
            x="2"
            y="26"
            style={{
              fontFamily: 'sans-serif',
              stroke: '2',
              fontSize: '12px',
              fill: '#fff',
            }}
          >
            135
          </text>
        </g>
      </g>
    </svg>
  );
};
export default CvvIcon;
